import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { validateLogin } from "../../services/validate-login";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { v4 as uuidv4 } from "uuid";
import { getFormattedDate } from "../../utils/dateFormat";
import { getUserLoanEligibility } from "../../services/userService";
import Loader2 from "../../components/common/Loader2";

function Form() {
  const [amount, setAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [draft, setDraft] = useState<any>({
    bpp_id: '',
    bpp_uri: '',
    form_id: '',
    form_url: '',
    item_id: '',
    loan_code: '',
    prev_msg_id: '',
    provider_id: '',
    screen_name: '',
    submission_id: '',
    transaction_id: '',
    version: '',
  });
  const [loanEligibility, setLoanEligibility] = useState(false);
  const [formIsComplete, setFormIsComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // 👈 new state
  const [showDraftPopup, setShowDraftPopup] = useState(false); // 👈 new state
  const [showHomeBtn, setHomeBtn] = useState(false); // 👈 new state
  const navigate = useNavigate();

  // Fetch offers from REST API
  useEffect(() => {
    async function fetchLoanProfile() {
      try {
        setLoading(true);
        const response = await getUserLoanEligibility("Personal Loan");
        console.log(response);
        if (response.success) {
          localStorage.setItem("hl_kyc",response.hl_kyc)
          setLoanEligibility(true);
          if(response?.message?.draft?.any_journey){
            setDraft(response?.message?.draft)
            setShowDraftPopup(true); // 👈 show popup if not eligible
          }
        } else {
          setLoanEligibility(false);
          setMessage(response.message)
          if(response.message == "Please complete your account HL Declaration to avail loan"){
            setTitle("HL Declaration Pending")
            setHomeBtn(false)
          }
          else{
            setTitle("Limit Reached – Please Try Later")
            setHomeBtn(true)
          }
          setShowPopup(true); // 👈 show popup if not eligible
        }
      } catch (err) {
        console.error("Error fetching offers:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchLoanProfile();
  }, []);

  const onClickEvent = () => {
    localStorage.setItem("message_id", uuidv4());
    localStorage.setItem("loan_code", "PERSONAL_LOAN");
    localStorage.setItem("loan_amount", amount);
    localStorage.setItem("tenure", tenure);
    localStorage.setItem("step0TimeStamp", getFormattedDate());
    localStorage.setItem("step", "1");
    navigate("/basic-details");
  };

  const checkForm = () => {
    if (
      amount != null &&
      tenure != null &&
      Number(amount) >= 30000 &&
      Number(tenure) >= 3 &&
      Number(tenure) <= 120
    ) {
      setFormIsComplete(true);
    } else {
      setFormIsComplete(false);
    }
    if (amount != null && Number(amount) >= 30000 && Number(tenure) > 120) {
      setTenure("120");
      setFormIsComplete(true);
    } else if (Number(tenure) > 120) {
      setTenure("120");
    }
  };

  const resumeJourney = () => {
    console.log(draft)
    switch (draft.screen_name) {
      case "OffersByLenderStepSeven":
        localStorage.setItem("step", "5")
        localStorage.setItem("transaction_id", draft.transaction_id)
        navigate("/offer-by-lenders");
        break;
      // case "HLEKycWidget":
      //   localStorage.setItem("transaction_id", draft.transaction_id)
      //   localStorage.setItem("message_id", draft.message_id)
      //   if(draft.submission_id == ""){
      //     localStorage.setItem("step", "6")
      //     navigate("/offer-details");
      //   }
      //   else {
      //     localStorage.setItem("step", "8")
      //     localStorage.setItem("ekyc_submission_id", draft.submission_id)
      //     navigate("/get-lenders-kyc");
      //   }
      //   break;
      case "KycAuthenticationStepNine":
        localStorage.setItem("step", "8")
        localStorage.setItem("transaction_id", draft.transaction_id)
        localStorage.setItem("message_id", draft.message_id)
         navigate("/get-lenders-kyc");
        break;
      case "BankDetails":
        localStorage.setItem("step", "9")
        localStorage.setItem("transaction_id", draft.transaction_id)
        localStorage.setItem("message_id", draft.message_id)
        navigate("/bank-details");
        break;
      case "EMandateWidget":
        localStorage.setItem("transaction_id", draft.transaction_id)
        localStorage.setItem("message_id", draft.message_id)
        localStorage.setItem("step", "10")
        if(draft.submission_id != ""){
          localStorage.setItem("emandate_submission_id", draft.submission_id)
        }
        navigate("/e-mandate");
        break;
      case "ESignWidget":
        localStorage.setItem("transaction_id", draft.transaction_id)
        localStorage.setItem("message_id", draft.message_id)
        localStorage.setItem("step", "11")
        if(draft.submission_id != ""){
          localStorage.setItem("esign_submission_id", draft.submission_id)
        }
        navigate("/e-sign");
        break;
      default:
        break;
    }
  }

  // 👉 Show loader full screen while fetching
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader2 />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
      {/* Popup if not eligible */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-96 text-center">
            <h2 className="text-lg font-semibold mb-4 text-red-600">
              {title}
            </h2>
            <p className="text-gray-600 mb-6">
              {message}
            </p>
            {!showHomeBtn && (
              <button
              onClick={() => navigate("/my-account")} // 👈 redirect page
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
              >
                My Account
              </button>
            )}
            {showHomeBtn && (
              <button
              onClick={() => navigate("/dashboard")} // 👈 redirect page
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
            >
              Home
            </button>
            )}
          </div>
        </div>
      )}

      {showDraftPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-96 text-center">
            <h2 className="text-lg font-semibold mb-4 text-red-600">
              You have a past loan application
            </h2>
            <p className="text-gray-600 mb-6">
              Want to resume or submit a new application?
            </p>

            {/* Button row */}
            <div className="flex gap-4">
              <button
                onClick={() => resumeJourney()}
                className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
              >
                RESUME 
              </button>
              <button
                onClick={() => setShowDraftPopup(false)}
                className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition"
              >
                APPLY NEW
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/img1.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 1
          </div>

          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">PERSONAL LOAN</h2>
            <p className="text-sm text-gray-600 mb-4">
              Enter your desired amount and tenure
            </p>

            {/* Extra Fields */}
            <div className="space-y-6">
              {/* Text Field */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Desired Loan Amount (min. Rs. 30000)
                </label>
                <div className="flex items-center border border-gray-300 rounded-lg">
                  <span className="px-3 text-gray-600">Rs.</span>
                  <input
                    type="number"
                    min={30000}
                    value={amount}
                    onKeyUp={(e) => checkForm()}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter Amount"
                    className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                  />
                </div>
              </div>

              {/* Duration Field */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Desired Loan Duration (min. 3 & max. 120 months)
                </label>
                <input
                  min={3}
                  max={120}
                  type="number"
                  value={tenure}
                  onKeyUp={(e) => checkForm()}
                  onChange={(e) => setTenure(e.target.value)}
                  placeholder="Enter Months"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            </div>
          </div>

          {/* Next Button pinned at bottom */}
          <div className="mt-6">
            <button
              className={`w-full px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${
                  !formIsComplete
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              onClick={() => onClickEvent()}
              disabled={!formIsComplete}
            >
              Next <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* Footer Stats */}
      <Footer />
    </div>
  );
}

export default function Step1LoanAmountTenurePage() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      {/* Main Content scrollable */}
      <main className="flex-1 overflow-y-auto">
        <Form />
      </main>
    </div>
  );
}
